import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EfImg from '@elem/ui/ef-img';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

const SectionU3 = () => {
    const { t } = useLang('theProduct.SectionU3');

    return (
        <div className={styles.SectionU3}>
            <EcoSpace />
            <EcoSectionCommon title={t('title')} />
            <EcoSpaceSmall />
            <div className="eco-content">
                <div className="main-banner">
                    <EfImg
                        pc="https://websiteoss.ecoflow.com/upload/image/1745497867152/banner.jpg"
                        pad="https://websiteoss.ecoflow.com/upload/image/1745497867152/banner.jpg"
                        h5="https://websiteoss.ecoflow.com/upload/image/1745497872563/banner_h5.jpg"
                    />
                </div>

                <div className="small-cards">
                    <div className="card-item">
                        <div className="card-img">
                            <EfImg
                                pc="https://websiteoss.ecoflow.com/upload/image/1745497974797/p1_h5.jpg"
                                pad="https://websiteoss.ecoflow.com/upload/image/1745497974797/p1_h5.jpg"
                                h5="https://websiteoss.ecoflow.com/upload/image/1745497974797/p1_h5.jpg"
                            />
                        </div>
                        <div className="info">{t('p1')}</div>
                    </div>
                    <div className="card-item">
                        <div className="card-img">
                            <EfImg
                                pc="https://websiteoss.ecoflow.com/upload/image/1745498002071/p2.jpg"
                                pad="https://websiteoss.ecoflow.com/upload/image/1745498002071/p2.jpg"
                                h5="https://websiteoss.ecoflow.com/upload/image/1745498004827/p2_h5.jpg"
                            />
                        </div>
                        <div className="info">{t('p2')}</div>
                    </div>
                    <div className="card-item">
                        <div className="card-img">
                            <EfImg
                                pc="https://websiteoss.ecoflow.com/upload/image/1745498036020/p3.jpg"
                                pad="https://websiteoss.ecoflow.com/upload/image/1745498036020/p3.jpg"
                                h5="https://websiteoss.ecoflow.com/upload/image/1745498038730/p3_h5.jpg"
                            />
                        </div>
                        <div className="info">{t('p3')}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SectionU3;
